export default defineNuxtPlugin(async (nuxtApp) => {
  if (!import.meta.client) return;

  const authUser = useState<any>("auth-user", () => null);
  const authStatus = useState<string>("auth-status", () => "idle");
  const authReady = useState<boolean>("auth-ready", () => false);

  try {
    // Check if we have hydrated state from SSR
    if (nuxtApp.payload.authUser) {
      authUser.value = nuxtApp.payload.authUser;
      authStatus.value = (nuxtApp.payload.authStatus as string) ?? "unauthenticated";
    } else if (authUser.value) {
      console.log("[Auth Plugin] Using existing auth state");
    } else {
      // No SSR state, check if we should restore from cookie
      authStatus.value = "unauthenticated";
    }
  } catch (error) {
    console.error("[Auth Plugin] Initialization error:", error);
    authStatus.value = "unauthenticated";
    authUser.value = null;
  } finally {
    authReady.value = true;
  }

  if (authStatus.value === "authenticated") {
    setupSessionMonitoring();
  }

  watch(authStatus, (newStatus, oldStatus) => {
    if (newStatus === "authenticated" && oldStatus !== "authenticated") {
      setupSessionMonitoring();
    }
  });
});

let monitoringInterval: NodeJS.Timeout | null = null;
let visibilityHandler: (() => void) | null = null;

function setupSessionMonitoring() {
  if (!import.meta.client) return;

  // Clean up existing monitoring
  cleanupSessionMonitoring();

  const { fetchUser } = useAuth();
  const authStatus = useState<string>("auth-status");

  monitoringInterval = setInterval(async () => {
    if (authStatus.value === "authenticated") {
      try {
        await fetchUser();
      } catch (error) {
        console.warn("[Auth Monitor] Session validation failed:", error);
      }
    } else {
      cleanupSessionMonitoring();
    }
  }, 5 * 60 * 1000);

  // Re-validate when tab becomes visible
  visibilityHandler = async () => {
    if (
      document.visibilityState === "visible" &&
      authStatus.value === "authenticated"
    ) {
      try {
        await fetchUser();
      } catch (error) {
        console.warn("[Auth Monitor] Visibility check failed:", error);
      }
    }
  };

  document.addEventListener("visibilitychange", visibilityHandler);

  // Cleanup on page unload
  window.addEventListener("beforeunload", cleanupSessionMonitoring, {
    once: true,
  });
}

function cleanupSessionMonitoring() {
  if (monitoringInterval) {
    clearInterval(monitoringInterval);
    monitoringInterval = null;
  }

  if (visibilityHandler) {
    document.removeEventListener("visibilitychange", visibilityHandler);
    visibilityHandler = null;
  }
}
